import { ColDef } from 'ag-grid-community';
import { stringComparator } from 'src/app/shared/utils/ag-grid-comparators';

/** Columnas del modal Firmante (Envio simple): checkbox + datos de contacto del maestro. */
export class GridColDefsEmpleadosSeleccionFirmante {
  columnDefs: ColDef[] = [
    {
      colId: 'seleccion',
      headerName: '',
      width: 48,
      maxWidth: 48,
      minWidth: 48,
      checkboxSelection: true,
      headerCheckboxSelection: false,
      sortable: false,
      resizable: false,
      suppressMenu: true,
      suppressNavigable: true,
      valueGetter: () => '',
      cellClass: 'empleados-seleccion-checkbox-cell',
      headerClass: 'empleados-seleccion-checkbox-header'
    },
    {
      headerName: 'Nombre',
      field: 'nombre',
      sortable: true,
      resizable: true,
      headerClass: 'header',
      width: 160,
      comparator: stringComparator
    },
    {
      headerName: 'Apellido 1',
      field: 'apellido1',
      sortable: true,
      resizable: true,
      headerClass: 'header',
      width: 160,
      comparator: stringComparator
    },
    {
      headerName: 'Apellido 2',
      field: 'apellido2',
      sortable: true,
      resizable: true,
      headerClass: 'header',
      width: 160,
      comparator: stringComparator
    },
    {
      headerName: 'Nif',
      field: 'nif',
      sortable: true,
      resizable: true,
      headerClass: 'header',
      width: 130
    },
    {
      headerName: 'Empresa',
      field: 'nombreEmpresa',
      sortable: true,
      resizable: true,
      headerClass: 'header',
      width: 260,
      comparator: stringComparator,
      cellRenderer: params => {
        const codigoEmpresaGrid =
          params.data.codigoEmpresa == null || params.data.codigoEmpresa.toUpperCase() === 'NULL'
            ? ''
            : params.data.codigoEmpresa;
        const nombreEmpresaGrid =
          params.data.nombreEmpresa == null || params.data.nombreEmpresa.toUpperCase() === 'NULL'
            ? ''
            : params.data.nombreEmpresa;
        return `${codigoEmpresaGrid} - ${nombreEmpresaGrid}`;
      }
    },
    {
      headerName: 'Centro',
      field: 'nombreCentro',
      sortable: true,
      resizable: true,
      headerClass: 'header',
      width: 260,
      cellRenderer: params => {
        const codigoCentroGrid =
          params.data.codigoCentro == null || params.data.codigoCentro.toUpperCase() === 'NULL'
            ? ''
            : params.data.codigoCentro;
        const nombreCentroGrid =
          params.data.nombreCentro == null || params.data.nombreCentro.toUpperCase() === 'NULL'
            ? ''
            : params.data.nombreCentro;
        return `${codigoCentroGrid} - ${nombreCentroGrid}`;
      }
    },
    {
      headerName: 'E-mail personal',
      field: 'mailPersonal',
      sortable: true,
      resizable: true,
      headerClass: 'header',
      width: 220,
      comparator: stringComparator
    }
  ];
}
